import { GamePlayData, LocationEnum } from '../types'

// 2D array representing travel costs between locations (in USD)
const TRAVEL_COSTS: number[][] = [
  //MED  FRA   POR   SAF   CAL   AUE   IND   AUW   HAW   TAH
  [0, 300, 450, 1000, 1200, 1500, 900, 1600, 1800, 2000], // Mediterranean
  [300, 0, 100, 1000, 1100, 1400, 800, 1500, 1700, 1900], // France
  [450, 100, 0, 900, 1000, 1300, 750, 1400, 1600, 1800], // Portugal
  [1000, 1000, 900, 0, 1500, 800, 600, 900, 1200, 1400], // South Africa
  [1200, 1100, 1000, 1500, 0, 300, 800, 300, 500, 700], // California
  [1500, 1400, 1300, 800, 2000, 0, 300, 300, 800, 1000], // Australia East Coast
  [900, 800, 750, 600, 800, 300, 0, 400, 600, 800], // Indonesia
  [1600, 1500, 1400, 900, 2000, 300, 400, 0, 700, 900], // Australia West Coast
  [1800, 1700, 1600, 1200, 500, 800, 600, 700, 0, 300], // Hawaii
  [2000, 1900, 1800, 1400, 700, 1000, 800, 900, 300, 0] // Tahiti
]

const LOCATION_INDEX: { [key in LocationEnum]: number } = {
  mediterranean: 0,
  france: 1,
  portugal: 2,
  south_africa: 3,
  california: 4,
  australia_east_coast: 5,
  indonesia: 6,
  australia_west_coast: 7,
  hawaii: 8,
  tahiti: 9
}

// Travel costs between surf spots within each location (in USD)
const TRAVEL_COSTS_WITHIN_LOCATION: { [key in LocationEnum]: number } = {
  mediterranean: 25,
  france: 35,
  portugal: 25,
  south_africa: 30,
  california: 70,
  australia_east_coast: 60,
  indonesia: 150,
  australia_west_coast: 60,
  hawaii: 200,
  tahiti: 250
}

export function getTravelCostsBetweenLocations(fromLocation: LocationEnum, toLocation: LocationEnum): number {
  const fromIndex = LOCATION_INDEX[fromLocation]
  const toIndex = LOCATION_INDEX[toLocation]

  if (fromIndex === undefined || toIndex === undefined) {
    throw new Error('Invalid location')
  }

  return TRAVEL_COSTS[fromIndex][toIndex]
}

export function getTravelCostsInLocation(location: LocationEnum): number {
  const cost = TRAVEL_COSTS_WITHIN_LOCATION[location]

  if (cost === undefined) {
    throw new Error('Invalid location')
  }

  return cost
}

export function getTravelCostsFromCurrentLocation(gameData: GamePlayData, toLocation: LocationEnum): number {
  const isLocationChange = gameData.currentLocation !== toLocation
  return isLocationChange
    ? getTravelCostsBetweenLocations(gameData.currentLocation, toLocation)
    : getTravelCostsInLocation(toLocation)
}
